export default Object.freeze({
  TITLE: 'e-mail 관리',
  TAB_ONE: 'e-mail 발송',
  TAB_TWO: 'e-mail 템플릿 설정',
  TAB_THREE: '자동e-mail 설정',
  TAB_FOUR: '자동e-mail 발송내역 조회',
  TAB_FIVE: '자동e-mail 사용내역 조회',
  DETAIL_ONE: 'ⓘ 쇼핑몰에서 회원에게 발송한 자동 e-mail 발송내역을 조회할 수 있습니다.',
  DETAIL_TWO: 'Ⓘ 요청ID 클릭 시, 수신자를 조회할 수 있습니다.',
  DETAIL_THREE: 'Ⓘ 발송된 e-mail 의 상세내용은 내용 클릭 시 확인이 가능합니다.',
  SEARCH_TITLE_TOP: '발송요청 일시',
  SEARCH_TITLE_BOTTOM: '발송요청 상태',
  YEAR: '년',
  MONTH: '월',
  TABLE_TITLE_BEFORE: '조회결과',
  TABLE_TITLE_AFTER: '건',
  PAGESIZE: '개 보기',
  MESSAGE_STATUS_ONE: '전체',
  MESSAGE_STATUS_TWO: '발송준비',
  MESSAGE_STATUS_THREE: '발송중',
  MESSAGE_STATUS_FOUR: '발송완료',
  MESSAGE_STATUS_CANCEL: '발송취소',
  MESSAGE_STATUS_FIVE: '발송실패',
  TABLE_HEADER_ONE: '요청 ID',
  TABLE_HEADER_TWO: '내용',
  TABLE_HEADER_THREE: '발송요청 상태',
  TABLE_HEADER_FOUR: '발송요청 일시',
  NO_DATA: '검색 결과가 없습니다.',
  POPUP_TITLE: 'e-mail 발송내용 상세보기',
  POPUP_TOP_HEADER: '요청ID',
  POPUP_BOTTOM_HEADER_ONE: '수신 메일',
  POPUP_BOTTOM_HEADER_TWO: '발송결과 상태',
  POPUP_BOTTOM_HEADER_THREE: '발송 일시',
  POPUP_STATUS_CODE_READY: '발송준비',
  POPUP_STATUS_CODE_PROGRESS: '발송중',
  POPUP_STATUS_CODE_COMPLETE: '발송완료',
  POPUP_STATUS_CODE_FAIL: '발송실패',
});
